import React, { useEffect, useState } from 'react';
import { Modal, Table, Tag, message } from 'antd';
import dayjs from 'dayjs';
import { getAudit } from '../api';
import { actionColors } from '../theme';

export default function AuditModal({ open, slug, getToken, onClose }) {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    setLoading(true);
    getToken()
      .then((token) => getAudit(token, slug))
      .then(setRecords)
      .catch(() => message.error('Failed to load history'))
      .finally(() => setLoading(false));
  }, [open, slug]);


  const columns = [
    {
      title: 'When',
      dataIndex: 'created_at',
      render: (d) => dayjs(d).format('MMM D, YYYY HH:mm')
    },
    { title: 'Actor', dataIndex: 'actor_upn', ellipsis: true },
    {
      title: 'Action',
      dataIndex: 'action',
      render: (a) => <Tag color={actionColors[a] || 'default'}>{a}</Tag>
    },
    {
      title: 'Summary',
      render: (_, record) => {
        const after = record.after_value ? JSON.parse(record.after_value) : null;
        const before = record.before_value ? JSON.parse(record.before_value) : null;
        switch (record.action) {
          case 'create':
            return `Created → ${after?.target_url}`;
          case 'edit': {
            const changes = [];
            if (before?.target_url !== after?.target_url) changes.push(`URL: ${after?.target_url}`);
            if (before?.description !== after?.description) changes.push(`Description: ${after?.description || '(cleared)'}`);
            if (before?.is_active !== after?.is_active) changes.push(after?.is_active ? 'Enabled' : 'Disabled');
            if (before?.expires_at !== after?.expires_at) changes.push(`Expiry: ${after?.expires_at || '(cleared)'}`);
            return changes.length ? changes.join(' | ') : 'No changes';
          }
          case 'delete':
            return `Deleted (was → ${before?.target_url})`;
          case 'enable':
            return 'Enabled';
          case 'disable':
            return 'Disabled';
          default:
            return record.action;
        }
      }
    }
  ];

  return (
    <Modal
      title={`History: ${slug}`}
      open={open}
      onCancel={onClose}
      footer={null}
      width={900}
    >
      <Table
        rowKey="id"
        columns={columns}
        dataSource={records}
        loading={loading}
        pagination={false}
        size="small"
      />
    </Modal>
  );
}
